import React, { Component } from 'react';
import PromptManager from '../promptManager';


var ReactSuperSelect = require('react-super-select')
const languageCodes = {
	english: { code: 'EN', color: 'darkblue' },
	spanish: { code: 'ES', color: 'darkgreen' },
	french: { code: 'FR', color: 'purple' },
	german: { code: 'DE', color: 'orange' },
	italian: { code: 'IT', color: 'red' },
	portuguese: { code: 'PT', color: 'brown' },
	russian: { code: 'RU', color: 'black' },
	mandarin: { code: 'ZH', color: 'brown' },
	japanese: { code: 'JA', color: 'pink' },
	arabic: { code: 'AR', color: 'gray' },
	hebrew: { code: 'HE', color: 'blue' },
	haitian: { code: 'HT', color: 'green' },
	korean: { code: 'KO', color: 'violet' },
	bengali: { code: 'BN', color: 'orange' },
	romanian: { code: 'RO', color: 'lightorange' },
	serbian: { code: 'SR', color: 'lightred' },
	turkish: { code: 'TR', color: 'lightbrown' },
	ukrainian: { code: 'UK', color: 'lightblack' },
	vietnamese: { code: 'VI', color: 'lightyellow' },
	cantonese: { code: 'YUE', color: 'teal' }, // Added
	urdu: { code: 'UR', color: 'lightblue' },  // Added
	polish: { code: 'PL', color: 'lightgreen' } // Added
};

class Prompts extends Component {
	constructor(props) {
		super(props);
		this.state = {
			editPrompt: false,
			filterBy: {}, sortBy: 'DisplayName', sortOrder: 1,
			loading: false,
			type: "special"
		};
	}
	cancel = () => {
		this.setState({ editPrompt: false, loading: false, error: '' })
	}
	editPrompt = (prompt) => e => {
		this.setState({ editPrompt: true, promptID: prompt, loading: false, error: '' })
	}
	add = () => {
		this.setState({ editPrompt: true, promptID: null, loading: false, error: '' })
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmEditNumber();
		}
	}
	toggle = (param) => (e) => {
		var newState = Object.assign({}, this.state)
		newState[param] = this.state[param] ? false : true
		this.setState(newState)
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			}
		}
	}
	checkType = (e) => {
		console.log(e.target.value)
		this.setState({ type: e.target.value })
	}
	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (prop === 'language') {
					if (object[prop].indexOf(filterBy[prop]) < 0) {
						return false
					}

				} else {
					if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
						return false
					}
				}

			}
			return true
		})
	}

	filterIcon(item) {
		return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
	}

	filterByDropdown = (value) => {
		var filterBy = this.state.filterBy
		if (!value) {
			delete filterBy.is_enabled
		} else if (value.id == 1) {
			filterBy.is_enabled = true
		} else if (value.id == 0) {
			filterBy.is_enabled = false
		}
		this.setState({ filterBy: filterBy })

	}

	render() {
		if (this.props.active) {
			if (this.state.type === "" || this.state.type === undefined) {
				this.setState({ type: "custom" })
			}


			var promptList = []
			var prompts = JSON.parse(JSON.stringify(this.props.data.Prompts.data));
			// //Filtering List
			if (Object.keys(this.state.filterBy).length > 0) {
				prompts = this.filterFunc(prompts, this.state.filterBy)
			}
			// //Sorting List
			if (this.state.sortBy !== '') {
				prompts.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}
			prompts = prompts.filter((prompt) => {
				return prompt.type === this.state.type
			})




			for (var prompt of prompts) {
				// Take the language array and replace the text with the proper code in languageCodes then make the array a string separated by commas
				var languageBoxes = prompt.language.map((lang, index) => {
					if (index < 3 || (index === 3 && prompt.language.length === 4)) {
						console.log(lang)
						const langInfo = languageCodes[lang];
						return (
							<div
								key={lang}
								style={{
									display: 'inline-block',
									backgroundColor: langInfo.color,
									color: 'white',
									borderRadius: '4px',
									padding: '2px 4px',
									marginRight: '4px',
									marginBottom: '4px',
									lineHeight: '25px',
									fontSize: '14px',
								}}
								title={lang.charAt(0).toUpperCase() + lang.slice(1)} // Tooltip text
								onMouseOver={(e) => e.target.innerText = lang.charAt(0).toUpperCase() + lang.slice(1)} // Hover effect
								onMouseOut={(e) => e.target.innerText = langInfo.code} // Reset on mouse out
							>
								{langInfo.code}
							</div>
						);
					} else if (index === 3) {
						const extraCount = prompt.language.length - 4; // Calculate number of extra languages
						return (
							<div
								key="extra"
								style={{
									display: 'inline-block',
									backgroundColor: '#2a6aa9',
									color: 'white',
									borderRadius: '4px',
									padding: '2px 4px',
									marginRight: '4px',
									marginBottom: '4px',
									lineHeight: '25px',
									fontSize: '14px',
								}}
								title={"More Languages"} // Tooltip for extra languages
							>
								{'+' + extraCount}
							</div>
						);
					}
				}).filter(Boolean); // Filter out undefined elements for languages beyond the 4th

				promptList.push(
					<tr className="dataRow" onClick={this.editPrompt(prompt.id)} key={prompt.id}>
						<td style={{ flex: '1 0 180px', textAlign: 'left' }}>{prompt.name.includes('.') ? prompt.name.split('.')[0] : prompt.name}</td>
						<td style={{ flex: '0 0 150px', textAlign: 'left' }}>{languageBoxes}</td>
						<td style={{ flex: '0 0 250px', textAlign: 'left' }}>{prompt.lastUpdatedUser}</td>
						<td style={{ flex: '0 0 200px', textAlign: 'right' }}>{prompt.lastUpdatedDate}</td>
					</tr>
				);
			}
			// filter prompt list by type

			// filter prompt list by type



			var languageFilter = []
			for (var language of this.props.data.Prompts.settings.language) {
				languageFilter.push(<option key={language} value={language}>{(language.charAt(0).toUpperCase() + language.slice(1))}</option>)
			}
			languageFilter.unshift(<option value="">  --Select--  </option>)


			var editPrompt = ""
			if (this.state.editPrompt) {
				//render promptManager
				//get the prompt object from prompts
				var prompt = this.props.data.Prompts.data.filter((prompt) => { return prompt.id === this.state.promptID })[0]
				editPrompt = (
					<PromptManager prompt={prompt} data={this.props.data.Prompts} cancel={this.cancel} ws={this.props.ws} />
				)
			}


			var addButton = ""
			if (this.state.type === 'custom') {
				addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a Prompt" onClick={this.add} />
			}


			return (
				<div width="100%">
					{addButton}
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<div style={{ width: '280px', marginRight: '10px' }}>
							<div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
								<label className="switch">
									<div style={{ width: '250px' }}>
										<select value={this.state.type} onChange={this.checkType} style={{ display: 'inline-block', flex: '1 0 0', marginBottom: '5px', height: '40px', padding: '0 10px', border: '1px solid #ddd', borderRadius: '4px', fontWeight: 'bold', fontSize: '20px', color: '#137', lineHeight: '24px' }}>
											{this.props.data.Prompts.settings.types.includes("custom") && <option value="custom">Custom Prompts</option>}
											{this.props.data.Prompts.settings.types.includes("special") && <option value="special">Special Prompts</option>}
											{this.props.data.Prompts.settings.types.includes("system") && <option value="system">System Prompts</option>}
										</select>
									</div>
								</label>
							</div>
							<div className="filterBox">

								<h4>Filter By:</h4>
								<div style={{ width: '250px' }}>
									<label>Name:</label>
									<input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
								</div>
								<div>
									<label>Language:</label>
									<select onChange={this.filter("language")} value={this.state.filterBy.Language}>
										{languageFilter}
									</select>
								</div>
								<div style={{ width: '250px' }}>
									<label>User:   </label>
									<input type="text" onChange={this.filter("lastUpdatedUser")} value={this.state.filterBy.User} />
								</div>
							</div>
						</div>
						<div style={{ flex: 1 }}>
							<table>
								<thead>
									<tr className="dataRow">
										<th style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
										<th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("language")}>Language {this.filterIcon("language")}</th>
										<th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("lastUpdatedUser")}>Last Updated User {this.filterIcon("lastUpdatedUser")}</th>
										<th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastUpdatedDate")}>Last Updated Date {this.filterIcon("lastUpdatedDate")}</th>
									</tr>
								</thead>
								<tbody>
									{promptList}
								</tbody>
							</table>
						</div>
					</div >
					{editPrompt}
				</div >
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}


const icon = "menuMic"
const roles = ["View"]
export { Prompts, icon, roles }


